import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import LoadingButton from '@mui/lab/LoadingButton';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import { useRouter } from '../../routes/hook';
import { useSiteContext } from '../site/context/site-context';
import { useSettingsContext } from '../settings/context/settings-context';

export default function TempConfigButtons() {
  const router = useRouter();
  const settings = useSettingsContext();
  
  const {
    hasTempChanges,
    applyTempConfig,
    clearTempConfig,
    getPreviousTempConfig,
    getNextTempConfig,
    hasPreviousTempConfig,
    hasNextTempConfig,
    tempConfigHistory,
    historyIndex,
  } = useSiteContext();

  const [isApplying, setIsApplying] = useState(false);

  const handleApply = async () => {
    try {
      setIsApplying(true);
      await applyTempConfig();
    } catch (error) {
      console.error('Error applying configuration:', error);
    } finally {
      setIsApplying(false);
    }
  };
  
  const getCurrentHistoryItemPath = () => {
    if (historyIndex >= 0 && historyIndex < tempConfigHistory.length) {
      return tempConfigHistory[historyIndex].pagePath;
    }
    return null;
  };

  const navigateToChangePage = () => {
    const pagePath = getCurrentHistoryItemPath();
    if (pagePath && pagePath !== window.location.pathname) {
      router.push(pagePath);
    }
  };
  
  if (!hasTempChanges) {
    return null;
  }

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'} sx={{ mb: { xs: 3, md: 5 } }}>
      <Alert 
        variant="outlined"
        severity="info"
        sx={{
          p: 2,
        }} 
      >
        保存された設定変更があります。「適用」ボタンをクリックして変更を適用してください。
        履歴を使用して以前の変更に戻ることもできます。「クリア」ボタンで一時保存をリセットできます。
      </Alert>
      <Stack direction="column" spacing={1} sx={{ mt: 1 }}>
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <LoadingButton
            variant="outlined"
            size="small"
            disabled={!hasPreviousTempConfig()}
            onClick={() => getPreviousTempConfig()}
            sx={{ whiteSpace: 'nowrap' }}
          >
            前の変更
          </LoadingButton>
          <LoadingButton
            variant="outlined"
            size="small"
            disabled={!hasNextTempConfig()}
            onClick={() => getNextTempConfig()}
            sx={{ whiteSpace: 'nowrap' }}
          >
            次の変更
          </LoadingButton>
          <Button
            variant="contained"
            color="custom-grey"
            size="small"
            onClick={navigateToChangePage}
            sx={{ whiteSpace: 'nowrap' }}
          >
            変更ページへ
          </Button>
        </Stack>
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <LoadingButton
            size="small"
            onClick={clearTempConfig}
          >
            クリア
          </LoadingButton>            
          <LoadingButton
            variant="contained"
            size="small"
            loading={isApplying}
            onClick={handleApply}
          >
            適用
          </LoadingButton>
        </Stack>        
      </Stack>
    </Container>
  );
}
